export interface CommunityPost {
  id: string;
  authorName: string;
  authorRole: 'student' | 'teacher' | 'parent';
  authorAvatar: string;
  content: string;
  image?: string;
  likes: number;
  comments: number;
  createdAt: string;
  tags: string[];
}

export interface CulturalFact {
  id: string;
  title: string;
  content: string;
  image: string;
  category: string;
}

export const communityPosts: CommunityPost[] = [
  {
    id: "1",
    authorName: "Cô Nguyễn Thị Hoa",
    authorRole: "teacher",
    authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20kind%20Vietnamese%20woman%20teacher%2C%20warm%20smile%2C%20traditional%20teaching%20clothes%2C%20soft%20warm%20colors%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=avatar1&orientation=squarish",
    content: "Hôm nay lớp 3A đã được chơi trò chơi kéo co của người Bahnar trên website Túi trò chơi dân gian Bahnar. Các em học sinh rất hào hứng và vui vẻ! Tôi rất vui khi thấy các em vừa được học vừa được khám phá nét văn hóa độc đáo của người Bahnar.",
    image: "https://readdy.ai/api/search-image?query=Group%20of%20cheerful%20Vietnamese%20primary%20school%20children%20playing%20jump%20rope%20outside%20in%20schoolyard%2C%20warm%20afternoon%20light%2C%20colorful%20uniforms%2C%20teacher%20watching%20and%20smiling%2C%20natural%20school%20setting%2C%20joyful%20atmosphere%2C%20candid%20educational%20photo%20style&width=500&height=320&seq=post1&orientation=landscape",
    likes: 24,
    comments: 8,
    createdAt: "2 giờ trước",
    tags: ["Kéo co", "Lớp 3A", "Trải nghiệm"]
  },
  {
    id: "2",
    authorName: "Em Đinh Văn Tuấn",
    authorRole: "student",
    authorAvatar: "https://readdy.ai/api/search-image?query=Cute%20chibi%20portrait%20of%20young%20Vietnamese%20boy%20student%2C%20cheerful%20smile%2C%20school%20uniform%2C%20soft%20warm%20colors%2C%20simple%20round%20face%2C%20kawaii%20style%2C%20small%20icon%20size%2C%20cream%20background&width=80&height=80&seq=avatar2&orientation=squarish",
    content: "Hôm nay em được tham gia Trò chơi Thi nướng cơm lam! Ban đầu em chưa biết cách lựa chọn các thực phẩm phù hợp và quy trình thực hiện như thế nào nhưng thầy giáo hướng dẫn em rất tỉ mỉ. Em muốn về nhà có thể vận dụng những điều từ trò chơi để có thể phụ giúp ba mẹ.",
    image: "https://readdy.ai/api/search-image?query=Vietnamese%20primary%20school%20boy%20spinning%20wooden%20top%20toy%20on%20ground%2C%20schoolyard%20setting%2C%20afternoon%20sunlight%2C%20happy%20expression%2C%20ethnic%20traditional%20game%2C%20warm%20colors%2C%20natural%20outdoor%20photography%20style&width=500&height=320&seq=post2&orientation=landscape",
    likes: 17,
    comments: 5,
    createdAt: "1 ngày trước",
    tags: ["ĐánhCù", "TròChơiDânGian", "VuiQuá"]
  }
];

export const culturalFacts: CulturalFact[] = [
  {
    id: "1",
    title: "Nhà Rông - Trái tim của làng",
    content: "Nhà Rông là ngôi nhà cộng đồng đặc trưng của người Bahnar với mái nhọn vươn cao. Đây là nơi tổ chức lễ hội, họp làng, và tiếp khách. Khi xây nhà Rông mới, cả làng cùng góp sức.",
    image: "https://readdy.ai/api/search-image?query=Illustration%20of%20traditional%20Bahnar%20Rong%20communal%20house%2C%20tall%20pointed%20thatched%20roof%20reaching%20toward%20sky%2C%20wooden%20pillars%20with%20ethnic%20carvings%2C%20warm%20sunset%20light%2C%20surrounded%20by%20tropical%20plants%2C%20cultural%20architectural%20heritage%20style%2C%20detailed%20artistic%20rendering&width=400&height=260&seq=culture1&orientation=landscape",
    category: "Kiến trúc"
  },
  {
    id: "2",
    title: "Trang phục dệt thủ công",
    content: "Người phụ nữ Bahnar nổi tiếng với nghề dệt thủ công truyền thống. Mỗi tấm vải đều mang hoa văn độc đáo, kể lên câu chuyện về cuộc sống, thiên nhiên và tín ngưỡng của dân tộc.",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Bahnar%20handwoven%20fabric%20with%20geometric%20ethnic%20patterns%20in%20red%20black%20and%20white%20colors%2C%20close%20up%20of%20intricate%20traditional%20weaving%2C%20cultural%20textile%20heritage%2C%20warm%20earthy%20tones%2C%20detailed%20craft%20illustration%20style&width=400&height=260&seq=culture2&orientation=landscape",
    category: "Nghề truyền thống"
  },
  {
    id: "3",
    title: "Lễ hội Pơ Thi",
    content: "Lễ hội Pơ Thi (lễ bỏ mả) là một trong những lễ hội quan trọng nhất của người Bahnar. Lễ được tổ chức long trọng với cồng chiêng, múa xoang và nhiều trò chơi dân gian đặc sắc.",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Bahnar%20Po%20Thi%20festival%20ceremony%20illustration%2C%20people%20in%20traditional%20clothing%20playing%20gongs%20and%20dancing%20around%20decorated%20grave%20site%2C%20warm%20firelight%20colors%2C%20tropical%20village%20setting%2C%20cultural%20celebration%2C%20artistic%20illustration%20style&width=400&height=260&seq=culture3&orientation=landscape",
    category: "Lễ hội"
  }
];
